import { useCallback } from 'react';
import { useWorkspace } from '../context/WorkspaceContext';
import { checkUserPermission } from '../lib/rolePermissions';

/**
 * Granular modular RBAC for the current user + company workspace.
 * @param {{ role?: string } | null | undefined} userData
 */
export function usePermissions(userData) {
  const { workspace } = useWorkspace();

  const checkPermission = useCallback(
    (moduleName, action) => checkUserPermission(
      userData?.role,
      workspace,
      moduleName,
      action,
    ),
    [userData?.role, workspace],
  );

  return { checkPermission };
}

export { checkUserPermission };
